import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
      paddingRight: "20px"
    },
  },
};


function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

export default function MultipleSelectPlaceholder({handleTranslationTypeChanges, required, id, triggerUpdateInParent, choices, label, valueInField, classesToAdd, renderOther}) {
  const theme = useTheme();
  // Always ensure personName is an array
  const [personName, setPersonName] = React.useState(Array.isArray(valueInField) ? valueInField : (typeof valueInField === "string" && valueInField.length > 0 ? [valueInField] : []));

  React.useEffect(() => {
    setPersonName(Array.isArray(valueInField) ? valueInField : (typeof valueInField === "string" && valueInField.length > 0 ? [valueInField] : []));
  }, [valueInField]);

  const handleChange = (event) => {
    let val = event.target.value;
    // Always convert to array
    let tempArray = Array.isArray(val) ? val : (typeof val === "string" && val.length > 0 ? [val] : []);
    setPersonName(tempArray);
    handleTranslationTypeChanges(tempArray);
    if (triggerUpdateInParent) triggerUpdateInParent(id, tempArray);

    if (renderOther !== undefined) {
      let foundOther = tempArray.includes("Other");
      renderOther(foundOther);
    }
  };

  function getStyles(name, personName, theme) {
    // Always treat personName as array
    return {
      fontWeight:
        Array.isArray(personName) && personName.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
  }

  return (
    <div>
      <FormControl sx={{ width: '100%',}}>
        <InputLabel id="demo-mutiple-checkbox-label" className={classesToAdd}><b style={{color: '#3f51b5 !important'}}>{label}</b></InputLabel>
        <Select
          multiple
          displayEmpty
          value={personName}
          style={{width:'100%'}}
          input={<OutlinedInput />}
          renderValue={(selected) => {
            // Always treat selected as array
            if (!Array.isArray(selected) || selected.length === 0) {
              return <em>{"Choose one or multiple"}</em>;
            }
            return selected.join(', ');
          }}
          onChange={handleChange}
          MenuProps={MenuProps}
          inputProps={{ 'aria-label': 'Without label' }}
        >
          <MenuItem disabled value="">
            <em>Types</em>
          </MenuItem>
          {choices.map((name) => (
            <MenuItem
              key={name}
              value={name}
              style={getStyles(name, personName, theme)}
            >
              {name}
            </MenuItem>
          ))}
        </Select>
        {required ? <span className="required-field-multiselect">*</span> : <span className="unrequired-field">*</span>}
      </FormControl>
    </div>
  );
}